import { render, staticRenderFns } from "./ChangeStatusToInRecycle.vue?vue&type=template&id=e0f74b80&scoped=true"
import script from "./ChangeStatusToInRecycle.vue?vue&type=script&lang=js"
export * from "./ChangeStatusToInRecycle.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusToInRecycle.vue?vue&type=style&index=0&id=e0f74b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f74b80",
  null
  
)

export default component.exports